module.exports = __webpack_public_path__ + "bec36d9fa32233b8069caaa1d9812b0d.jpg";